import { BiMessageStatus, MessageCategoryEnum, MessageTypeEnum, PriorityEnum, TemplateCategories } from '@schemax-whatsapp/shared-models';
import { PrimaryGeneratedColumn, Index, Entity, Column, ManyToOne, JoinColumn, OneToMany, CreateDateColumn, UpdateDateColumn, VersionColumn, Generated } from 'typeorm';
import { Modules } from './module.entity';

@Entity('bi_message')
export class BiMessage {

    @PrimaryGeneratedColumn('increment', {
        name: 'bi_message_id'
    })
    biMessageId: number;

    @Column('varchar', {
        nullable: false,
        length:50,
        name: 'role_escalation',
    })
    roleEscalation: string;

    @Column('text', {
        nullable: false,
        name: 'activity',
    })
    activity: string;

    @Column('text', {
        nullable: true,
        name: 'rule',
    })
    rule: string;

    @Column('text', {
        nullable: false,
        name: 'impact',
    })
    impact: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'message_type',
    })
    messageType: MessageTypeEnum;

    @Column('varchar', {
        nullable: false,
        length: 20,
        name: 'message_category',
    })
    messageCategory: TemplateCategories;

    @Column('tinyint', {
        nullable: false,
        name: 'priority',
    })
    priority: PriorityEnum;

    @Column('text', {
        nullable: false,
        name: 'qdc',
    })
    qdc: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @ManyToOne(type => Modules, mod => mod.biMessages, { nullable: false, onDelete: 'CASCADE' })
    @JoinColumn({ name: 'module_id' })
    module: Modules;

    @Column('text', {
        nullable: false,
        name: 'message_body',
    })
    messageBody: string;

    @Column('text', {
        nullable: false,
        name: 'template_name',
    })
    templateName: string;

    @Column('varchar', {
        nullable: false,
        length: 20,
        default:BiMessageStatus.WAITING_FOR_APPROVAL,
        name: 'message_status',
    })
    messageStatus: BiMessageStatus;

    @Column('text', {
        nullable: true,
        name: 'footer',
    })
    footer: string;

    @Column('varchar', {
        nullable: true,
        name: 'language',
    })
    language: string;
}

